<template>
  <v-form class="mb-3" autocomplete="off" @submit.prevent="">
    <v-row class="filters" align="center" justify="start">
      <v-col class="mt-0 pt-0 pr-11">
        <v-row class="mt-3">
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTerm"
              label="Hledat"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              :prepend-icon="filters.searchTerm ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTerm')"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model="filters.ids"
              v-mask="'######'"
              label="Id objednávky"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.ids ? 'mdi-close' : 'mdi-none'"
              min="1"
              step="1"
              @click:prepend="filters.ids = null"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <VAutocompleteWithValidation
              v-model="filters.types"
              label="Typ objednávky"
              outlined
              dense
              background-color="white"
              item-text="text"
              item-value="name"
              :items="types"
              :loading="typesLoading"
              :icon="filters.types ? 'mdi-close' : 'mdi-none'"
              multiple
              :custom-slot="true"
              @click:prepend="filters.types = null"
              @keydown.enter="filter()"
            >
              <template slot="item" slot-scope="{ item }">
                {{ item.text }}
              </template>
              <template slot="selection" slot-scope="{ index, item }">
                <span v-if="index === 0">
                  <template v-if="filters.types.length === 1">
                    {{ item.text }}
                  </template>
                  <template v-else-if="filters.types.length > 1 && filters.types.length < 5">
                    Vybrány {{ filters.types.length }} položky
                  </template>
                  <template v-else-if="filters.types.length > 4">
                    Vybráno {{ filters.types.length }} položek
                  </template>
                </span>
              </template>
            </VAutocompleteWithValidation>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <VAutocompleteWithValidation
              v-model="filters.statuses"
              label="Stav objednávky"
              outlined
              dense
              background-color="white"
              item-text="text"
              item-value="name"
              :items="statuses"
              :loading="statusesLoading"
              :icon="filters.statuses ? 'mdi-close' : 'mdi-none'"
              multiple
              :custom-slot="true"
              @click:prepend="filters.statuses = null"
              @keydown.enter="filter()"
            >
              <template slot="item" slot-scope="{ item }">
                {{ item.text }}
              </template>
              <template slot="selection" slot-scope="{ index, item }">
                <span v-if="index === 0">
                  <template v-if="filters.statuses.length === 1">
                    {{ item.text }}
                  </template>
                  <template v-else-if="filters.statuses.length > 1 && filters.statuses.length < 5">
                    Vybrány {{ filters.statuses.length }} položky
                  </template>
                  <template v-else-if="filters.statuses.length > 4">
                    Vybráno {{ filters.statuses.length }} položek
                  </template>
                </span>
              </template>
            </VAutocompleteWithValidation>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--from"
          >
            <v-text-field
              v-model.trim="dateFromFormatted"
              outlined
              dense
              background-color="white"
              label="Datum vytvoření od"
              append-icon="mdi-calendar-arrow-left"
              :prepend-icon="dateFromFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.dateSince = setParsedDateSince(dateFromFormatted)"
              @click:prepend="filters.dateSince = null"
              @click:append="menuForDateFrom = true"
            />

            <v-menu
              ref="menuForDateFrom"
              v-model="menuForDateFrom"
              attach=".filter-datepicker--from"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.dateSince"
                :first-day-of-week="1"
                :max="maxForDateFrom"
                no-title
                @input="menuForDateFrom = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--to"
          >
            <v-text-field
              v-model.trim="dateToFormatted"
              outlined
              dense
              background-color="white"
              label="Datum vytvoření do"
              append-icon="mdi-calendar-arrow-right"
              :prepend-icon="dateToFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.dateUntil = setParsedDateUntil(dateToFormatted)"
              @click:prepend="filters.dateUntil = null"
              @click:append="menuForDateTo = true"
            />
            <v-menu
              ref="menuForDateTo"
              v-model="menuForDateTo"
              attach=".filter-datepicker--to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.dateUntil"
                :first-day-of-week="1"
                :max="maxForDateTo"
                :min="minForDateTo"
                no-title
                @input="menuForDateTo = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--customer-birthday-from"
          >
            <v-text-field
              v-model.trim="customerBirthdayFromFormatted"
              outlined
              dense
              background-color="white"
              label="Datum narození od"
              append-icon="mdi-calendar-arrow-left"
              :prepend-icon="customerBirthdayFromFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="
                filters.customerBirthdaySince = setParsedCustomerBirthdaySince(
                  customerBirthdayFromFormatted
                )
              "
              @click:prepend="filters.customerBirthdaySince = null"
              @click:append="menuForCustomerBirthdayFrom = true"
            />

            <v-menu
              ref="menuForCustomerBirthdayFrom"
              v-model="menuForCustomerBirthdayFrom"
              attach=".filter-datepicker--customer-birthday-from"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.customerBirthdaySince"
                :first-day-of-week="1"
                :max="maxForDateFrom"
                no-title
                @input="menuForCustomerBirthdayFrom = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--customer-birthday-to"
          >
            <v-text-field
              v-model.trim="customerBirthdayToFormatted"
              outlined
              dense
              background-color="white"
              label="Datum narození do"
              append-icon="mdi-calendar-arrow-right"
              :prepend-icon="customerBirthdayToFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="
                filters.customerBirthdayUntil = setParsedCustomerBirthdayUntil(
                  customerBirthdayToFormatted
                )
              "
              @click:prepend="filters.customerBirthdayUntil = null"
              @click:append="menuForCustomerBirthdayTo = true"
            />
            <v-menu
              ref="menuForDateTo"
              v-model="menuForCustomerBirthdayTo"
              attach=".filter-datepicker--customer-birthday-to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.customerBirthdayUntil"
                :first-day-of-week="1"
                :max="maxForDateTo"
                :min="minForDateTo"
                no-title
                @input="menuForCustomerBirthdayTo = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pr-11 pb-6 text-right">
        <v-btn depressed height="40px" min-width="130px" outlined @click="resetFilter">
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
          @click="filter"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import parseDate from '@/utils/parseDate'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'
import { mapActions } from 'vuex'

export default {
  name: 'OrdersFilters',
  components: { VAutocompleteWithValidation },
  data() {
    return {
      dateFromFormatted: null,
      dateToFormatted: null,
      menuForDateFrom: false,
      menuForDateTo: false,
      customerBirthdayFromFormatted: null,
      customerBirthdayToFormatted: null,
      menuForCustomerBirthdayFrom: false,
      menuForCustomerBirthdayTo: false,
      filters: {
        searchTerm: null,
        ids: null,
        statuses: null,
        types: null,
        dateSince: null,
        dateUntil: null,
        customerBirthdaySince: null,
        customerBirthdayUntil: null,
      },
      types: [],
      typesLoading: false,
      statuses: [],
      statusesLoading: false,
    }
  },
  computed: {
    filtersFilled() {
      let state = false
      Object.keys(this.filters).forEach((filter) => {
        if (filter !== 'searchTerm') {
          if (this.filters[filter]) {
            state = true
            return true
          }
        }
        return state
      })
      return state
    },
    maxForDateFrom() {
      if (this.filters.dateUntil) {
        return new Date(this.filters.dateUntil).toISOString()
      }
      return new Date().toISOString()
    },
    maxForDateTo() {
      return new Date().toISOString()
    },
    minForDateTo() {
      if (this.filters.dateSince) {
        return new Date(this.filters.dateSince).toISOString()
      }
      return null
    },
  },
  watch: {
    'filters.dateSince': {
      handler() {
        this.dateFromFormatted = this.formatDate(this.filters.dateSince)
      },
    },
    'filters.dateUntil': {
      handler() {
        this.dateToFormatted = this.formatDate(this.filters.dateUntil)
      },
    },
    'filters.customerBirthdaySince': {
      handler() {
        this.customerBirthdayFromFormatted = this.formatDate(this.filters.customerBirthdaySince)
      },
    },
    'filters.customerBirthdayUntil': {
      handler() {
        this.customerBirthdayToFormatted = this.formatDate(this.filters.customerBirthdayUntil)
      },
    },
  },
  async created() {
    this.setFilter()
    this.loadOrderStatuses()
    this.loadOrderTypes()
  },
  methods: {
    ...mapActions({
      getOrderStatuses: 'enum/listOrderStatus',
      getOrderTypes: 'enum/listOrderType',
    }),
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    setParsedDateUntil(dateFormatted) {
      this.filters.dateUntil = parseDate(dateFormatted)
      return this.filters.dateUntil
    },
    setParsedDateSince(dateFormatted) {
      this.filters.dateSince = parseDate(dateFormatted)
      return this.filters.dateSince
    },
    setParsedCustomerBirthdayUntil(dateFormatted) {
      this.filters.customerBirthdayUntil = parseDate(dateFormatted)
      return this.filters.customerBirthdayUntil
    },
    setParsedCustomerBirthdaySince(dateFormatted) {
      this.filters.customerBirthdaySince = parseDate(dateFormatted)
      return this.filters.customerBirthdaySince
    },
    filter() {
      const filters = {
        ...this.filters,
      }
      this.$emit('filter', filters)
    },
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null
      this.filter()
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null
      })
      this.$emit('filter', this.filters)
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue
          if (key !== 'searchTerm') {
            this.filters[key] = Number(value) || value
          } else {
            this.filters[key] = value
          }
        })
      }
    },
    loadOrderStatuses() {
      this.statusesLoading = true
      this.getOrderStatuses()
        .then((response) => {
          this.statuses = response.data
        })
        .finally(() => {
          this.statusesLoading = false
        })
    },
    loadOrderTypes() {
      this.typesLoading = true
      this.getOrderTypes()
        .then((response) => {
          this.types = response.data
        })
        .finally(() => {
          this.typesLoading = false
        })
    },
  },
}
</script>
